export default (type, colors) => {
  const styles = {
    type1: {
      'wavesurfer__control--play-pause': {
        background: 'transparent',
        fontFamily: 'mmo-iconfont',
        customCSS: `
          .wavesurfer__control--play-pause i.control--play-pause:before {
            font-family: mmo-iconfont !important;
          }
        `
      },
      'wavesurfer__control--skip': {
        background: 'transparent',
        fontSize: '80px'
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/wavesurferСontrol.js